export default {
  buttons: {
    create: 'Aanmaken',
    update: 'Bijwerken',
    cancel: 'Annuleren',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Voer titel in',
    },
    description: {
      label: 'Beschrijving',
      placeholder: 'Voer beschrijving in',
    },
    button_text: {
      label: 'Knoptekst',
      placeholder: 'Voer knoptekst in',
    },
    button_url: {
      label: 'Knop-URL',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Afbeelding',
    },
  },
  title: 'Bericht aanmaken',
};
